export const coachFormIdData = {
    nickName: "2sJC",               // 닉네임
    isAvailable: "wLVT",            // 추가 매칭 가능 여부
    email: "excW",                  // 이메일
    introduceLine: "pmK7",          // 자기소개 한 줄 평
    profilePicture: "6hs6",         // 프로필 사진
    mbti: "oT47",                   // MBTI
    schoolName: "4jGc",             // 학교명
    departmentName: "fuaA",         // 학과명
    admissionType: "jBwS",          // 합격 입시 전형
    subjectTeachers: "sHqb",        // 수강 과목 강사
    freeIntroduction: "3d1X",       // 자유 소개
    classModes: "2nUQ",             // 가능 수업 형태
    coachAdmissionType: "bT25",     // 코치 가능 입시 전형
    minCoachingPeriod: "v6C4",      // 최소 코칭 보장 기간
    coachingSubjects: "dEFu",       // 코칭 가능 과목
    qaSubjects: "exCT",             // 질의 응답 가능 과목
    availableOnlineSchedule: "dPAs",      // 온라인 수업 가능 시간
    availableOfflineSchedule: "7EPo",   // 오프라인 수업 가능 시간
    classStyle: "qpvX",             // 수업 스타일
    goodStudentFit: "c35j",         // 이런 학생과 잘 맞아요!
    greetingToParents: "4hHj"       // 학부모님께 첫 수업 전 인사 멘트
  };